import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

interface IProps {
  verbose?: boolean;
}

const BlockPageLoader: React.FC<IProps> = ({verbose = false}: IProps) => {
  const text = verbose ? 'sometext' : null;
  return (
    <Backdrop style={{color: '#fff'}} open>
      <CircularProgress color="inherit" />
      {text}
    </Backdrop>
  );
};

export default BlockPageLoader;
